import { defineMessages } from 'react-intl';

export default defineMessages({
  FileUploadButtonText: {
    id: 'FileUpload.ButtonText',
    defaultMessage: 'Choose file',
  },
  FileUploadFileSizeExceeded: {
    id: 'FileUpload.Errors.FileSizeExceeded',
    defaultMessage: 'File size exceeds the maximum allowed file size (max {max})',
  },
  FileUploadFilesExceeded: {
    id: 'FileUpload.Errors.FilesExceeded',
    defaultMessage: 'Too many files selected (max {max})',
  },
  FileUploadInvalidFileType: {
    id: 'FileUpload.Errors.InvalidFileType',
    defaultMessage: 'Invalid file type.',
  },
  FileUploadUploadFailed: {
    id: 'FileUpload.Errors.FileUploadUploadFailed',
    defaultMessage: 'File could not be uploaded. Verify you have selected a valid document.',
  },
});
